
function isClosedChar(ch) {
    return [')', '"'].indexOf(ch) > -1;
}
function isOpenChar(ch) {
    return ['(', '"'].indexOf(ch) > -1;
}

export function formatExpectedResponse(str) {
    const keepedChars = [];
    let result = '';
    let insideQuotes = false;

    str = str.replace(/""/gi, "_")
        .replace(/(\|\||\|)/gi, ' $1 ')
        .replace(/(\&\&|\&)/gi, ' $1 ');

    let strParts = str.match(/"[^"]*"|\bOR\b|\bAND\b|\bNOT\b|\|\||\||&&|\&|\S+/gi).filter(el => !!el);

    str = '';
    for (let i = 0; i < strParts.length; i++) {
        let curEl = strParts[i];
        let prevEl = strParts[i - 1];

        if (curEl.includes('"') && insideQuotes === false) {
            insideQuotes = true;
        }

        if (i === 0) {
            str += curEl;
        } else {
            if (curEl) {
                const isLogicalOperator = ['or', 'and', 'not', '|', '||', '&', '&&'].includes(curEl.toLowerCase());
                const isPrevLogicalOperator = ['or', 'and', 'not', '(not', '|', '||', '&', '&&', ')', '('].includes(prevEl?.toLowerCase());
                const isNextClosingParent = curEl === ')';

                if (prevEl?.toLowerCase() === 'not') {
                    str += ' ' + curEl;
                } else if (!insideQuotes && !isLogicalOperator && !isPrevLogicalOperator && !isNextClosingParent) {
                    str += ' AND ' + curEl;
                } else {
                    str += ' ' + curEl;
                    if (curEl.includes('"') && insideQuotes) {
                        insideQuotes = false;
                    }
                }
            }
        }
    }

    const charPairs = {
        ')': '(',
        '(': ')',
        '"': '"',
    };

    for (let i = 0; i < str.length; i++) {
        const lastKeepedChar = keepedChars[keepedChars.length - 1];
        if (isOpenChar(str[i]) && str[i] !== lastKeepedChar) {
            keepedChars.push(str[i]);
            if (str[i] === "(") {
                if (isCharInsideUrl(str, i)) {
                    result += str[i];
                } else {
                    result += '<b>' + str[i] + '</b>';
                }
            } else if (str[i] === '"') {
                result += str[i];
            }
        } else if (isClosedChar(str[i])) {
            if (charPairs[str[i]] === lastKeepedChar) {
                keepedChars.pop();
                if (str[i] === ")") {
                    if (isCharInsideUrl(str, i)) {
                        result += str[i];
                    } else {
                        result += '<b>' + str[i] + '</b>';
                    }
                } else if (str[i] === '"') {
                    result += str[i];
                }
            }
        } else {
            result += str[i];
        }
    }
    return result;
}

function getUrlIndices(text) {
    const urlRegex = /https?:\/\/[^\s]+/gi;
    let match;
    const indices = [];

    while ((match = urlRegex.exec(text)) !== null) {
        indices.push([match.index, match.index + match[0].length - 1]);
    }

    return indices;
}

function isCharInsideUrl(text, charIndex) {
    const urlIndices = getUrlIndices(text);

    for (const [start, end] of urlIndices) {
        if (charIndex >= start && charIndex <= end) {
            return true;
        }
    }

    return false;
}
